import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AuthRedirectService } from '../../services/auth-redirect.service';
import { MessageService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activate-account',
  standalone: true,
  imports: [ProgressSpinnerModule, CommonModule, RouterLink],
  templateUrl: './activate-account.component.html',
  styleUrl: './activate-account.component.scss',
})
export class ActivateAccountComponent implements OnInit {
  isLoading = true;
  isSuccess = false;
  isFalha = false;

  // Dependency injections
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly authRedirectService = inject(AuthRedirectService);
  private readonly messageService = inject(MessageService);

  ngOnInit(): void {
    const userId = this.route.snapshot.queryParamMap.get('userId');
    const token = this.route.snapshot.queryParamMap.get('token');

    if (userId && token) {
      this.authService.activateAccount(userId, token).subscribe({
        next: (res: any) => {
          this.isSuccess = true;
          this.messageService.add({
            severity: 'success',
            summary: 'Conta ativada',
            detail: 'A sua conta foi ativada com sucesso. Faça login!',
            life: 5000,
          });
          this.isLoading = false;

          const returnUrl = this.authRedirectService.getReturnUrl(this.route);
          setTimeout(() => {
            if (returnUrl) {
              this.router.navigate(['/auth/login'], {
                queryParams: { returnUrl },
              });
            } else {
              this.router.navigate(['/auth/login']);
            }
          }, 3000);
        },
        error: (err) => {
          console.error(err);
          this.isSuccess = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Falha',
            detail: `${err?.mensagem || err?.message || 'Falha ao ativar a conta'}`,
            life: 5000,
          });
          this.isLoading = false;
          this.isFalha = true;
          setTimeout(() => this.router.navigate(['/']), 3000);
        },
      });
    } else {
      this.isLoading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Falha',
        detail: `Link inválido.`,
        life: 5000,
      });
      console.error('Link inválido: userId ou token ausente.');
      setTimeout(() => this.router.navigate(['/']), 3000);
    }
  }

  goToLogin(): void {
    const returnUrl = this.authRedirectService.getReturnUrl(this.route);
    if (returnUrl) {
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl } });
    } else {
      this.router.navigate(['/auth/login']);
    }
  }
}
